import { Trans } from '@lingui/macro';
import dayjs from 'dayjs';
import React from 'react';

export const InstructionRunTodayInfo = {
    title: () => (
        <Trans>Create Transaction Today</Trans>
    ),
    onOk: (_, handleOk, action) => {
        const newAction = {...action};
        newAction.request.instruction_run_today_feedback = true;
        handleOk(newAction);
    },
    bodyStyle: {},
    noPasscode: true,
};

function InstructionRunToday(props) {
    const {details} = props;
    const {
        first_transaction_date,
        // instruction_process_date,
        // post_dating,
    } = details;

    const formatDate = dateString => (dateString ? dayjs(dateString).format('DD/MM/YYYY') : '');

    return (
        <span>
            <p>
                <Trans>
                    The transaction dated {formatDate(first_transaction_date)} will be created today based on the settings.
                </Trans>
            </p>
            <p>
                <Trans>Do you want to proceed?</Trans>
            </p>
        </span>
    );
}

export default InstructionRunToday;
